import { cn } from '@/lib/utils';

const sizes = {
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-6 w-6 border-[3px]',
} as const;

interface SpinnerProps {
  size?: keyof typeof sizes;
  className?: string;
  /** Beschriftung für Screenreader. */
  label?: string;
}

/**
 * Kanonischer Lade-Spinner (Border, `currentColor`). Erbt die Textfarbe des
 * Kontexts — auf farbigen Buttons also weiss, auf hellen Flächen brand/slate.
 * Bewusst eine Variante. Für Layout-Loading (Platzhalter-Blöcke) `<Skeleton>` nutzen.
 *
 * Die Drehung ist ein funktionaler Zustandsindikator und bleibt auch bei
 * `prefers-reduced-motion` erhalten (Norm für Loader).
 */
export function Spinner({ size = 'md', className, label = 'Lädt …' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent',
        sizes[size],
        className,
      )}
    />
  );
}
